import React from 'react';
import { ListFieldSection } from '../../../../Layout';
import { Field, TextOutput } from '../../../../Core';
import { IWorksheetComponent, WorksheetsResultsMessagesSection } from '../../../Core';
import { withInjectedProps } from 'Components/Core/InjectedPropsContext';
import { useSelector } from 'react-redux';

let BsResultsSection: React.FC<IWorksheetComponent> = ({ createWorksheetSelector }) => {
  const containsDissolvedSalt = useSelector(createWorksheetSelector!('Preparation.ContainsDissolvedSalt'));

  return (
    <>
      <WorksheetsResultsMessagesSection />
      <ListFieldSection>
        <Field input={<TextOutput />} name="Results.MoistureContentPercent" />
        <Field visible={containsDissolvedSalt} input={<TextOutput />} name="Results.FluidContent" />
      </ListFieldSection>
    </>
  );
};

BsResultsSection = withInjectedProps(BsResultsSection);

export { BsResultsSection };
export default BsResultsSection;
